<!--
 * @Author: 1739017283@qq.com
 * @Date: 2025-04-07 15:09:12
 * @LastEditors: 1739017283@qq.com
 * @LastEditTime: 2025-04-08 10:30:05
 * @FilePath: \knowledge-graph\src\views\Login\regist.vue
 * @Description: 注册
-->
<template>
  <div class="com-login-container">
    <div class="com-login-container-left">
      <img src="@/assets/login/login-bg.png" alt="">
    </div>
    <div class="com-login-container-right">
      <h2>登录知识图谱研阅系统</h2>
      <div class="com-login-container-right-form-item">
        <img src="@/assets/login/phone.png" alt="">
        <input type="text" placeholder="请输入注册手机号" />
      </div>
      <div class="com-login-container-right-form-code">
        <div class="com-login-container-right-form-item code-input">
          <img src="@/assets/login/password.png" alt="">
          <input type="text" placeholder="请输入验证码" />
        </div>
        <div class="com-login-container-right-form-code-btn">获取验证码</div>
      </div>
      <div class="com-login-container-right-form-item">
        <img src="@/assets/login/password.png" alt="">
        <input type="text" placeholder="请输入登录密码" />
      </div>
      <div class="com-login-container-right-form-item">
        <img src="@/assets/login/password.png" alt="">
        <input type="text" placeholder="请再次输入登录密码" />
      </div>
      <div class="com-login-container-right-form-link">
        <span></span>
        <div>
          如果已有账号，请
          <span @click.stop="$emit('jump', 'login')">登录</span>
        </div>
      </div>
      <div class="com-login-container-right-form-btn">注册</div>
      <div class="com-login-container-right-form-agree">
        <div class="com-login-container-right-form-agree-checkbox" :class="{ checked }" @click.stop="checked = !checked"></div>
        <label for="agree">我已阅读并同意<a>《用户协议》</a>和<a>《隐私政策》</a></label>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'RegistIndex',
  data () {
    return {
      checked: false
    }
  }
}
</script>
